import { withIconProps } from "../icons/withIconProps";
import Big from "./logo-big.svg?react";
import GNB from "./logo-gnb.svg?react";

export const LogoBig = withIconProps(Big);
export const LogoGNB = withIconProps(GNB);
